import React from 'react';
import { Skeleton, SkeletonItem, mergeClasses } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import './GuideComponents.css';

export interface GuideSkeletonProps {
  /** Cantidad de barras grises. */
  rows?: number;
  /** Texto debajo; por defecto "Cargando…". */
  label?: string;
  className?: string;
  'data-testid'?: string;
}

/** Carga de la guía: skeleton con barras grises y el texto "Cargando…" (`aria-busy`). */
export const GuideSkeleton = ({ rows = 3, label, className, 'data-testid': testId }: GuideSkeletonProps) => {
  const { t } = useTranslation();
  const text = label ?? (t('guideComponents.loading') as string);
  return (
    <div className={mergeClasses('ichtys-skeleton', className)} data-testid={testId} aria-busy="true">
      <Skeleton aria-label={text}>
        {Array.from({ length: rows }).map((_, index) => (
          <SkeletonItem key={index} className="ichtys-skeleton__row" size={16} />
        ))}
      </Skeleton>
      <span className="ichtys-skeleton__label">{text}</span>
    </div>
  );
};

export default GuideSkeleton;
